import type { ComponentProps } from 'react';
import { Avatar, AvatarFallback } from '@ooh/ui/components/avatar';
import { Badge } from '@ooh/ui/components/badge';

interface ClientOfferPageHeaderProps {
  brandInitial: string;
  brandName: string;
  brandSubtitle: string;
  offerTitle: string;
  offerMeta: string;
  statusVariant: ComponentProps<typeof Badge>['variant'];
  statusLabel: string;
}

export function ClientOfferPageHeader({
  brandInitial,
  brandName,
  brandSubtitle,
  offerTitle,
  offerMeta,
  statusVariant,
  statusLabel,
}: ClientOfferPageHeaderProps) {
  return (
    <header
      className="shrink-0 border-b border-border/60 bg-background"
      data-testid="client-offer-header"
    >
      <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <Avatar className="h-9 w-9 bg-primary">
            <AvatarFallback className="bg-primary text-sm font-bold text-primary-foreground">
              {brandInitial}
            </AvatarFallback>
          </Avatar>
          <div>
            <p className="text-[13px] font-semibold leading-tight text-foreground">{brandName}</p>
            <p className="text-2xs leading-tight text-muted-foreground">{brandSubtitle}</p>
          </div>
        </div>

        <div className="mx-8 hidden min-w-0 flex-1 sm:block">
          <p
            className="truncate text-[15px] font-semibold text-foreground"
            data-testid="offer-title"
          >
            {offerTitle}
          </p>
          <p className="truncate text-xs text-muted-foreground">{offerMeta}</p>
        </div>

        <Badge variant={statusVariant} className="shrink-0 text-2xs">
          {statusLabel}
        </Badge>
      </div>
    </header>
  );
}
